import { useQuery } from 'urql';

import {
  type CustomRoleTaxonomySelection,
  ROLE_SELECTION_LIST_QUERY,
} from '@revelio/data-access';

import type {
  RoleSelectionListKey,
  SelectionListState,
} from '../../../../shared/selection-lists/types';
import { useIsTaxonomyResolved } from '../contexts/FilterProvider';
import { useFilterState } from '../hooks/useFilters';
import { FilterId, type SingleValueFilter } from '../types/filters';

export type RoleSelectionListState = SelectionListState<RoleSelectionListKey>;

export const useRoleSelectionLists = (
  taxonomyIdOverride?: CustomRoleTaxonomySelection
): RoleSelectionListState | null => {
  const { filterState: roleTaxonomyFilterState } = useFilterState<
    SingleValueFilter<CustomRoleTaxonomySelection>
  >(FilterId.ROLE_TAXONOMY);
  const isTaxonomyResolved = useIsTaxonomyResolved();

  const taxonomyId: CustomRoleTaxonomySelection =
    taxonomyIdOverride ?? roleTaxonomyFilterState.value;
  const { version: _version, ...taxonomyIdWithoutVersion } = taxonomyId;

  const [{ data: roleSelectionList }] = useQuery({
    query: ROLE_SELECTION_LIST_QUERY,
    variables: { taxonomyId: taxonomyIdWithoutVersion },
    pause: !isTaxonomyResolved,
  });

  return (roleSelectionList?.selectionList ??
    null) as RoleSelectionListState | null;
};
